import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { returnOneProductUrl } from "../api/endpoints";
import { returnOneProductInTodayTransaction } from "../tools/indexdb";
import { addToQueue } from "../slice/offlineQueue";
import { IoArrowUndoSharp } from "react-icons/io5";
import { uiAlert } from "./alerts/customAlert/uiAlert";

const EachProductSold = ({
  product,
  whichOperation,
  transId,
  updateSelectedTrans,
  customer,
  setAlertDisplay,
  fetchTodayTransactionFromIBD,
  fetchTodayTransaction,
  queriedTrans,
  currency,
  todayTrans,
  displayedTimeline,
}) => {
  const [returned, setReturned] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { employee } = useSelector((state) => state.employee);

  const dispatch = useDispatch();

  useEffect(() => {
    setReturned(product.returned);
  }, [product]);

  const returnProduct = async () => {
    let payload = {
      transactionID: transId,
      productID: product.id,
      customer,
      subUnitID: product.isSubUnitSold ? product.subUnitId : null,
      employee,
    };
    if (window.confirm("Are you sure you want to return this item?\nItem would be added back to your stock")) {
      console.log(todayTrans, "todayTrans", displayedTimeline);

      try {
        if (queriedTrans || displayedTimeline === null) {
          console.log("queriedTrans or not today trans", queriedTrans);

          try {
            let response = await fetch(returnOneProductUrl + store._id, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              body: JSON.stringify(payload),
            });

            if (!response.ok) {
              throw new Error("Network response was not ok");
            }

            let { transaction, returnedProduct, updatedStoreProductCollection } = await response.json();

            setReturned(true);
            updateSelectedTrans(transaction);
            // fetchTodayTransaction();
            fetchTodayTransactionFromIBD();
            setAlertDisplay({
              showAlert: true,
              title: "Item returned",
              message: returnedProduct.name + " " + " has been added back to stock",
              type: "success",
            });
          } catch (error) {
            console.log("Error returning product:", error);
            setAlertDisplay({
              showAlert: true,
              title: "Item not returned",
              message: "There was an error returning the item. Please try again.",
              type: "error",
            });
          }
        } else {
          let { transactionList, modifiedTransaction, modifiedProduct, error } = await returnOneProductInTodayTransaction(
            store.storeName,
            transId,
            product.id,
            product.isSubUnitSold ? product.subUnitId : null
          );

          if (error) {
            return uiAlert(error || "There was an error returning the item. Please try again.", "error");
          }

          if (modifiedProduct) {
            setReturned(true);
            updateSelectedTrans(modifiedTransaction);
            fetchTodayTransactionFromIBD();
            setAlertDisplay({
              showAlert: true,
              title: "Item returned",
              message: modifiedProduct.name + " " + " has been added back to the stock",
              type: "success",
            });

            let offlinePayload = {
              fetchPayload: payload,
              fetchUrl: returnOneProductUrl + store._id,
              fetchMethod: "PUT",
              fetchAccessToken: localStorage.getItem("accessToken"),
              storeID: store._id,
              queueID: Math.random().toString(36).substring(2) + Date.now().toString(36), // unique id for the queue item
            };
            dispatch(addToQueue(offlinePayload));
          } else {
            setAlertDisplay({
              showAlert: true,
              title: "Item not returned",
              message: "Item could not be returned",
              type: "error",
            });
          }
        }
      } catch (error) {
        console.log(error);
        uiAlert(error || "There was an error returning the item. Please try again.", "error");
      }
    }
  };
  let imageUrl = product.productImage
    ? `${product.productImage?.split("/upload/")[0]}/upload/f_auto,q_auto,w_122/${product.productImage.split("/upload/")[1]}`
    : "https://res.cloudinary.com/ebuka1122/image/upload/…6/static%20images%20storelens/download_bvjych.png";

  return (
    <>
      {queriedTrans ? (
        <div key={product.id} className='txn-dtl-v2-product-card'>
          <div className='txn-dtl-v2-product-image'>
            <img src={imageUrl} alt={product.name} />
          </div>
          <div className='txn-dtl-v2-product-info-wrapper'>
            <h3 className='txn-dtl-v2-product-name'>{product.name}</h3>
            <div className='txn-dtl-v2-product-details'>
              <div className='txn-dtl-v2-product-detail-row'>
                <span className='txn-dtl-v2-detail-label'>Qty</span>
                <span className='txn-dtl-v2-detail-value'>{product.quantity}</span>
              </div>
              <div className='txn-dtl-v2-product-detail-row'>
                <span className='txn-dtl-v2-detail-label'>Unit price</span>
                <span className='txn-dtl-v2-detail-value'>kr{product.soldUnitPrice.toLocaleString()}</span>
              </div>
            </div>
          </div>
          {whichOperation === "cash" ? (
            !returned ? (
              <button onClick={returnProduct} className='txn-dtl-v2-return-item-btn'>
                <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <polyline points='9 14 4 9 9 4' />
                  <path d='M20 20v-7a4 4 0 0 0-4-4H4' />
                </svg>
                Return
              </button>
            ) : (
              <button
                disabled
                style={{
                  backgroundColor: "rgba(160, 155, 155, 0.5)",
                  cursor: "not-allowed",
                }}
                className='txn-dtl-v2-return-item-btn'
              >
                <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <polyline points='9 14 4 9 9 4' />
                  <path d='M20 20v-7a4 4 0 0 0-4-4H4' />
                </svg>
                Returned
              </button>
            )
          ) : (
            <button
              disabled
              style={{
                backgroundColor: "rgba(200, 200, 200, 0.5)",
                cursor: "not-allowed",
              }}
              className='txn-dtl-v2-return-item-btn'
            >
              <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                <polyline points='9 14 4 9 9 4' />
                <path d='M20 20v-7a4 4 0 0 0-4-4H4' />
              </svg>
              Can't return
            </button>
          )}
        </div>
      ) : (
        <div className='TransListItemDiv'>
          <img alt='Product image' src={imageUrl} />
          <div>
            <p className='PnameTD54'>{product.name}</p>
            <span>Qty: {product.quantity}</span>
            <span>
              Unit price: {currency}
              {product.soldUnitPrice?.toLocaleString()}
            </span>
          </div>
          {whichOperation === "cash" ? (
            !returned ? (
              <button onClick={returnProduct}>
                Return item <IoArrowUndoSharp />{" "}
              </button>
            ) : (
              <button style={{ backgroundColor: "gainsboro", border: "none", color: "rgb(67, 67, 67)" }}>item was returned</button>
            )
          ) : (
            <button>
              {" "}
              {currency} {product.totalAmount}{" "}
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default EachProductSold;
